import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, FormGroup, Label } from 'reactstrap';
import Select, { components } from "react-select";

const ColourTable = (props) => {
    const { setValue, trigger, disabledInputs, settingColours, settingMainSolidColours, settingColourFamilies, colourRows, setColourRows } = props;

    const handleRowChange = (idx, field, value) => {
        setColourRows(prev => prev.map((row, i) => i === idx ? { ...row, [field]: value } : row));
    };

    useEffect(() => {
        setValue("colours", [...colourRows]);
        trigger("colours");
    }, [colourRows]);

    return (
        <FormGroup>
            <Label className="form-label ai-form-heading">Colour Details</Label>
            <table className="table table-bordered table-sm align-middle">
                <thead>
                    <tr>
                        <th style={{ width: '33%' }}>Colours</th>
                        <th style={{ width: '33%' }}>Main Solid Colours</th>
                        <th>Colour Family</th>
                    </tr>
                </thead>
                <tbody>
                    {(colourRows || []).map((row, idx) => (
                        <tr key={idx}>
                            <td>
                                <Select
                                    placeholder="Select Colour"
                                    isDisabled={true}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    options={settingColours}
                                    value={settingColours.find(opt => opt.id === row.colour) || null}
                                    onChange={selected => handleRowChange(idx, 'colour', selected ? selected.id : '')}
                                    // className={errors.colours ? "is-invalid" : ""}
                                />
                            </td>
                            <td>
                                <Select
                                    placeholder="Select Main Solid Colour"
                                    isDisabled={(disabledInputs && disabledInputs.colours) ? disabledInputs.colours.find(opt => (opt.colour === row.colour && opt.colour == opt.main_solid_colour)) : false}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    options={settingMainSolidColours}
                                    value={settingMainSolidColours.find(opt => opt.id === row.main_solid_colour) || null}
                                    onChange={selected => handleRowChange(idx, 'main_solid_colour', selected ? selected.id : '')}
                                    // className={errors.main_solid_colour ? "is-invalid" : ""}
                                />
                            </td>
                            <td>
                                <Select
                                    placeholder="Select Colour Family"
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    options={settingColourFamilies}
                                    value={settingColourFamilies.find(opt => opt.id === row.colour_family) || null}
                                    onChange={selected => handleRowChange(idx, 'colour_family', selected ? selected.id : '')}
                                    // className={errors.colour_family ? "is-invalid" : ""}
                                    isClearable={true}
                                    components={{
                                        IndicatorSeparator: () => null,
                                        DropdownIndicator: (props) => {
                                            return row.colour_family ? null : <components.DropdownIndicator {...props} />;
                                        }
                                    }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </FormGroup>
    );
};

export default ColourTable;
